// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#members-link {
  margin: 0 1rem;
  border-radius: 1.25rem;
  border: 1px solid white;
  text-transform: uppercase;
}

#members-link:hover {
  background-color: var(--primary-color);
  color: black;
  border: 1px solid var(--primary-color);
}

header a {
  text-decoration: none;
}

header a:hover {
  text-shadow: 0px 0px 1px black;
  color: black;
}
header {
  background-color: var(--secondary-color);
  position: relative;
  color: white;
  font-family: "WMFD-Bold";
  display: flex;
  padding: 0rem 2rem;
  width: 100vw;
  overflow: hidden;
  z-index: 100;
  box-sizing: border-box;
  transition: 0.5s ease-in-out;
  transition-property: transform;
}

#sublinks {
  font-family: "WMFD-Bold";
  box-sizing: border-box;
  display: flex;
  padding-right: 2rem;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  position: relative;
  z-index: 100;
  height: 3rem;
}

#sublinks > a {
  color: white;
  display: flex;
  align-items: center;
  padding: 1rem;
}

#header-left {
  flex: 1 1;
  display: flex;
  padding: 1rem 0rem;
}

#header-right {
  flex: 9 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

#navbar {
  box-sizing: border-box;
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: flex-end;
  margin-right: 1rem;
  width: -moz-fit-content;
  width: fit-content;
}

#navbar > a {
  padding: 0rem 1rem;
  width: -moz-fit-content;
  width: fit-content;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
}

/* .link {
  padding: 0rem 1rem;
  width: fit-content;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
} */

/* #navbar > a:hover {
  background-color: var(--primary-color);
} */

.link-selected {
  background-color: var(--primary-color);
}

#navbar a:visited,
a:link,
a:active {
  color: inherit;
  text-decoration: none;
}

#navbar a:link {
  color: inherit;
  /* text-decoration: none; */
}

#language-selector {
  box-sizing: border-box;
  display: flex;
  flex: 1 1;
  align-items: center;
  margin-right: 1rem;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0rem 1rem;
}

.language {
  text-transform: uppercase;
}

.language:hover {
  color: var(--primary-color);
  cursor: pointer;
}

.link:hover > span {
  color: black;
}

#mobile-navbar-button {
  display: none;
}

#mobile-language-button {
  display: none;
}

#mobile-navbar {
  box-sizing: border-box;
  display: flex;
  height: 100vh;
  flex-direction: row;
  background-color: white;
  z-index: 2000;
  position: fixed;
  width: 50vw;
  border-right: 4px solid var(--primary-color);
  transition: 0.5s ease-in-out;
  transition-property: transform;
}

#mobile-language {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 1;
  position: fixed;
  top: 10vh;
  right: 0;
  transition: 0.5s ease-in-out;
  transition-property: transform;
  width: 6rem;
}

#mobile-language .language {
  width: 100%;
  padding: 1rem 0rem;
  text-align: center;
  font-family: "WMFD-Bold";
}

.mobile-navbar-closed-state {
  transform: translateX(-100vw);
}

.mobile-language-closed-state {
  transform: translateX(100vw);
}

#mobile-navbar-container {
  display: flex;
  flex-direction: column;
  flex: 9 1;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
}

.mobile-sublink-group {
  display: none;
  flex-direction: column;
}

#mobile-navbar-close {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  height: 100vh;
}

#mobile-navbar-close-button {
  font-size: 4rem;
  color: var(--primary-color);
}

#language-selector-mobile {
  display: flex;
  justify-content: center;
}

#language-selector-mobile > a {
  padding: 0.75rem 1rem;
  font-family: "WMFD-Bold";
  flex: 1 1;
  text-align: center;
}

#mobile-navbar-container > a {
  padding-left: 1rem;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  font-family: "WMFD-Bold";
  color: white;
  width: 100%;
  box-sizing: border-box;
}

.mobile-link {
  padding: 0.5rem;
  background-color: var(--secondary-color);
  margin-top: 0.2rem;
  text-align: left;
}
.mobile-sublink {
  padding: 1rem 0rem 1rem 1.5rem;
  background-color: var(--tertiary-color);
  border-bottom: 1px solid white;
  text-align: left;
  font-family: "WMFD-SemiBold";
  text-decoration: none;
  color: white;
}

.mobile-sublink:visited {
  color: white;
}

@media (max-width: 1250px) {
  #navbar a {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  .link {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  #sublinks a {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  #language-selector > a {
    font-size: 0.75rem;
  }
}

@media (min-width: 1001px) {
  #mobile-navbar {
    display: none;
  }
}
@media (max-width: 1000px) {
  #mobile-navbar {
    width: 100vw;
  }

  .mobile-navbar-open {
    transform: translateX(100vw);
  }

  .mobile-language-open {
    transform: translateY(-10vw);
  }

  #mobile-navbar-button {
    display: flex;
    transform: scale(1.5);
  }

  #mobile-language-button {
    display: flex;
    transform: scale(1.5);
  }

  #logo {
    width: 150px;
  }
  #header-right {
    display: none;
  }

  #sublinks {
    display: none;
  }

  #header-left {
    justify-content: center;
  }

  header {
    justify-content: flex-start;
    align-items: center;
    height: 10vh;
    overflow: visible;
  }

  .mobile-navbar-open.home-container {
    transform: translate(100vw, -10vh);
  }
}

@media (max-width: 425px) {
  #mobile-navbar-button {
    transform: scale(1.25);
  }

  #mobile-language-button {
    transform: scale(1.25);
  }

  header {
    padding: 0rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;;GAEG;;AAEH;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;EACX,4CAA4C;EAC5C,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["#members-link {\r\n  margin: 0 1rem;\r\n  border-radius: 1.25rem;\r\n  border: 1px solid white;\r\n  text-transform: uppercase;\r\n}\r\n\r\n#members-link:hover {\r\n  background-color: var(--primary-color);\r\n  color: black;\r\n  border: 1px solid var(--primary-color);\r\n}\r\n\r\nheader a {\r\n  text-decoration: none;\r\n}\r\n\r\nheader a:hover {\r\n  text-shadow: 0px 0px 1px black;\r\n  color: black;\r\n}\r\nheader {\r\n  background-color: var(--secondary-color);\r\n  position: relative;\r\n  color: white;\r\n  font-family: \"WMFD-Bold\";\r\n  display: flex;\r\n  padding: 0rem 2rem;\r\n  width: 100vw;\r\n  overflow: hidden;\r\n  z-index: 100;\r\n  box-sizing: border-box;\r\n  transition: 0.5s ease-in-out;\r\n  transition-property: transform;\r\n}\r\n\r\n#sublinks {\r\n  font-family: \"WMFD-Bold\";\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  padding-right: 2rem;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  position: relative;\r\n  z-index: 100;\r\n  height: 3rem;\r\n}\r\n\r\n#sublinks > a {\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1rem;\r\n}\r\n\r\n#header-left {\r\n  flex: 1;\r\n  display: flex;\r\n  padding: 1rem 0rem;\r\n}\r\n\r\n#header-right {\r\n  flex: 9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n\r\n#navbar {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex: 1;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  margin-right: 1rem;\r\n  width: fit-content;\r\n}\r\n\r\n#navbar > a {\r\n  padding: 0rem 1rem;\r\n  width: fit-content;\r\n  height: 100%;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* .link {\r\n  padding: 0rem 1rem;\r\n  width: fit-content;\r\n  height: 100%;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n} */\r\n\r\n/* #navbar > a:hover {\r\n  background-color: var(--primary-color);\r\n} */\r\n\r\n.link-selected {\r\n  background-color: var(--primary-color);\r\n}\r\n\r\n#navbar a:visited,\r\na:link,\r\na:active {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n#navbar a:link {\r\n  color: inherit;\r\n  /* text-decoration: none; */\r\n}\r\n\r\n#language-selector {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex: 1;\r\n  align-items: center;\r\n  margin-right: 1rem;\r\n  width: fit-content;\r\n  padding: 0rem 1rem;\r\n}\r\n\r\n.language {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.language:hover {\r\n  color: var(--primary-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.link:hover > span {\r\n  color: black;\r\n}\r\n\r\n#mobile-navbar-button {\r\n  display: none;\r\n}\r\n\r\n#mobile-language-button {\r\n  display: none;\r\n}\r\n\r\n#mobile-navbar {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  height: 100vh;\r\n  flex-direction: row;\r\n  background-color: white;\r\n  z-index: 2000;\r\n  position: fixed;\r\n  width: 50vw;\r\n  border-right: 4px solid var(--primary-color);\r\n  transition: 0.5s ease-in-out;\r\n  transition-property: transform;\r\n}\r\n\r\n#mobile-language {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: white;\r\n  z-index: 1;\r\n  position: fixed;\r\n  top: 10vh;\r\n  right: 0;\r\n  transition: 0.5s ease-in-out;\r\n  transition-property: transform;\r\n  width: 6rem;\r\n}\r\n\r\n#mobile-language .language {\r\n  width: 100%;\r\n  padding: 1rem 0rem;\r\n  text-align: center;\r\n  font-family: \"WMFD-Bold\";\r\n}\r\n\r\n.mobile-navbar-closed-state {\r\n  transform: translateX(-100vw);\r\n}\r\n\r\n.mobile-language-closed-state {\r\n  transform: translateX(100vw);\r\n}\r\n\r\n#mobile-navbar-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 9;\r\n  overflow-y: scroll !important;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.mobile-sublink-group {\r\n  display: none;\r\n  flex-direction: column;\r\n}\r\n\r\n#mobile-navbar-close {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex: 1;\r\n  height: 100vh;\r\n}\r\n\r\n#mobile-navbar-close-button {\r\n  font-size: 4rem;\r\n  color: var(--primary-color);\r\n}\r\n\r\n#language-selector-mobile {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n#language-selector-mobile > a {\r\n  padding: 0.75rem 1rem;\r\n  font-family: \"WMFD-Bold\";\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n#mobile-navbar-container > a {\r\n  padding-left: 1rem;\r\n  width: fit-content;\r\n  display: flex;\r\n  align-items: center;\r\n  font-family: \"WMFD-Bold\";\r\n  color: white;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.mobile-link {\r\n  padding: 0.5rem;\r\n  background-color: var(--secondary-color);\r\n  margin-top: 0.2rem;\r\n  text-align: left;\r\n}\r\n.mobile-sublink {\r\n  padding: 1rem 0rem 1rem 1.5rem;\r\n  background-color: var(--tertiary-color);\r\n  border-bottom: 1px solid white;\r\n  text-align: left;\r\n  font-family: \"WMFD-SemiBold\";\r\n  text-decoration: none;\r\n  color: white;\r\n}\r\n\r\n.mobile-sublink:visited {\r\n  color: white;\r\n}\r\n\r\n@media (max-width: 1250px) {\r\n  #navbar a {\r\n    font-size: 0.75rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .link {\r\n    font-size: 0.75rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  #sublinks a {\r\n    font-size: 0.75rem;\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  #language-selector > a {\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1001px) {\r\n  #mobile-navbar {\r\n    display: none;\r\n  }\r\n}\r\n@media (max-width: 1000px) {\r\n  #mobile-navbar {\r\n    width: 100vw;\r\n  }\r\n\r\n  .mobile-navbar-open {\r\n    transform: translateX(100vw);\r\n  }\r\n\r\n  .mobile-language-open {\r\n    transform: translateY(-10vw);\r\n  }\r\n\r\n  #mobile-navbar-button {\r\n    display: flex;\r\n    transform: scale(1.5);\r\n  }\r\n\r\n  #mobile-language-button {\r\n    display: flex;\r\n    transform: scale(1.5);\r\n  }\r\n\r\n  #logo {\r\n    width: 150px;\r\n  }\r\n  #header-right {\r\n    display: none;\r\n  }\r\n\r\n  #sublinks {\r\n    display: none;\r\n  }\r\n\r\n  #header-left {\r\n    justify-content: center;\r\n  }\r\n\r\n  header {\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    height: 10vh;\r\n    overflow: visible;\r\n  }\r\n\r\n  .mobile-navbar-open.home-container {\r\n    transform: translate(100vw, -10vh);\r\n  }\r\n}\r\n\r\n@media (max-width: 425px) {\r\n  #mobile-navbar-button {\r\n    transform: scale(1.25);\r\n  }\r\n\r\n  #mobile-language-button {\r\n    transform: scale(1.25);\r\n  }\r\n\r\n  header {\r\n    padding: 0rem 1.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
